import { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { DownloadIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { IconButton } from '@air/primitive-icon-button';
import { useShortIdContext } from '@air/provider-short-id';

import { useDownloadPublicAsset } from '~/hooks/useDownloadPublicAsset';
import { centralizedClipIdSelector } from '~/store/centralizedClip/selectors';

export const PublicAssetMobileDownloadButton = memo(() => {
  const { downloadPublicAsset } = useDownloadPublicAsset();
  const { shortId } = useShortIdContext();
  const clipId = useSelector(centralizedClipIdSelector);

  const handleDownload = useCallback(() => {
    if (!shortId || !clipId) {
      return;
    }
    // biome-ignore lint/nursery/noFloatingPromises: PLA-1724 — pre-existing debt, not introduced by the icon migration
    downloadPublicAsset({ shortId, clipId, trackLocation: 'public-asset-page' });
  }, [downloadPublicAsset, shortId, clipId]);

  return (
    <>
      <Button
        appearance="outline"
        className="xsm:flex hidden"
        color="gray"
        onClick={handleDownload}
        prefix={<DownloadIcon size="sm" />}
        size="large"
      >
        Download
      </Button>
      <IconButton
        adsIcon
        appearance="outline"
        className="flex xsm:hidden"
        color="gray"
        icon={DownloadIcon}
        label="Download"
        onClick={handleDownload}
        size="large"
      />
    </>
  );
});

PublicAssetMobileDownloadButton.displayName = 'PublicAssetMobileDownloadButton';
